import styled from 'styled-components';
import { defaultTheme } from '../../../../utils/defaultTheme';

export const ButtonWrapper = styled.div`
    img {
        width: 24.5px;
        height: 25.5px;
        opacity: ${({ exportDisabled }) => (exportDisabled ? '0.4' : '1')};
        cursor: ${({ exportDisabled }) => (exportDisabled ? 'not-allowed' : 'pointer')};
    }

    ${({ customStyle }) => customStyle}
`;

export const Button = styled.div`
    width: 115px;
    height: 40px;
    font-weight: 600;
    box-sizing: border-box;
    padding: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    border-radius: 3px;

    border: ${props => (props.disabled ? 'none' : `1px solid ${defaultTheme.blue[950]}`)};
    box-shadow: ${props => (props.disabled ? 'none' : `0px 0px 4px ${defaultTheme.black[29]}`)};
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${props => (props.disabled ? 0.7 : 1)};
    background: ${props => (props.disabled ? defaultTheme.grey[70] : defaultTheme.white.ff)};
    color: ${props => (props.disabled ? defaultTheme.blue['950-52'] : defaultTheme.blue[950])};

    transition: box-shadow 0.1s ease-in-out;
    user-select: none;

    &:hover {
        background: ${props => (props.disabled ? defaultTheme.grey[300] : defaultTheme.white.ff)};
        box-shadow: 0px 0px 10px ${defaultTheme.black[29]};
    }

    &:active {
        background: ${props => (props.disabled ? defaultTheme.grey[300] : defaultTheme.grey[50])};
    }

    p {
        text-align: center;
        width: 100%;
        font-size: 14px;
    }
`;
